import { Navigate } from "react-router-dom";
import { getApiUrlFromStorage, getTokenFromStorage } from "../helpers/helpers";

const ApiAuthChecker = () => {

  const apiUrl = getApiUrlFromStorage();
  const token = getTokenFromStorage();

  if (!apiUrl) {
    return <Navigate to='/api-url' />;
  }
  else if (!token) {
    return <Navigate to='/signin' />;
  }

  return <Navigate to='/activity-list' />;

}

export default ApiAuthChecker;